import { MenuClassification } from 'features/MenuList/models/menu';
import React from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import { useTranslation } from 'react-i18next';

interface FilterProps {
  menuClassifications: MenuClassification[];
  handleChangeName: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleChangeMenuCode: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleChangeMenuClassification: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  callFilter: () => void;
  name: string;
  menuCode: string;
  menuClass: string;
}

function Filter({
  menuClassifications,
  handleChangeName,
  handleChangeMenuCode,
  handleChangeMenuClassification,
  callFilter,
  name,
  menuCode,
  menuClass,
}: FilterProps) {
  const { t } = useTranslation();

  const filterGetMenuClass = (menuClass: string) => {
    const menuClassification = menuClassifications.find((value) => value.id === parseInt(menuClass));
    return menuClassification;
  };

  return (
    <>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>{t('MenuAddModal.search')}</Accordion.Header>
          <Accordion.Body>
            <Form.Group as={Row} className="mb-2">
              <Col sm={3}>
                <Form.Label className="col-form-label">{t('MenuAddModal.menu_classification')}</Form.Label>
              </Col>
              <Col sm={6}>
                <Form.Select onChange={handleChangeMenuClassification}>
                  <option key={-1} value="">
                    ------- 全て -------
                  </option>
                  {menuClassifications &&
                    menuClassifications.map((value: MenuClassification) => (
                      <option key={value.id} value={value.id}>
                        {value.name}
                      </option>
                    ))}
                </Form.Select>
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-2">
              <Col sm={3}>
                <Form.Label className="col-form-label">{t('MenuAddModal.name')}</Form.Label>
              </Col>
              <Col sm={6}>
                <Form.Control type="text" onChange={handleChangeName} />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-2">
              <Col sm={3}>
                <Form.Label className="col-form-label">{t('MenuAddModal.menu_code')}</Form.Label>
              </Col>
              <Col sm={6}>
                <Form.Control type="text" onChange={handleChangeMenuCode} />
              </Col>
              <Col sm={3}>
                <Button variant="primary" onClick={callFilter}>
                  {t('MenuAddModal.search')}
                </Button>
              </Col>
            </Form.Group>
          </Accordion.Body>
          <div className="accordion-body accordion-summary">
            <Row>
              <Col sm={'auto'}>
                <Form.Label htmlFor="control-1" className="col-form-label">
                  {t('MenuAddModal.menu_classification')} {filterGetMenuClass(menuClass)?.name}
                </Form.Label>
              </Col>
              <Col sm={'auto'}>
                <Form.Label htmlFor="control-1" className="col-form-label">
                  {t('MenuAddModal.name')} {name}
                </Form.Label>
              </Col>

              <Col sm={'auto'}>
                <Form.Label htmlFor="control-1" className="col-form-label">
                  {t('MenuAddModal.menu_code')} {menuCode}
                </Form.Label>
              </Col>
            </Row>
          </div>
        </Accordion.Item>
      </Accordion>
    </>
  );
}
export default Filter;
